import React, { useState } from "react";

const Contacto = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    celular: "",
    asunto: "",
    mensaje: "",
    aceptar: false,
  });

  const [mensaje, setMensaje] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!formData.aceptar) {
      setMensaje("Debes aceptar los términos y condiciones.");
      return;
    }
  
    try {
      const response = await fetch("http://localhost:5000/enviar-correo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json();
      setMensaje(data.message);
  
      
      setFormData({
        nombre: "",
        email: "",
        celular: "",
        asunto: "",
        mensaje: "",
        aceptar: false,
      });
    } catch (error) {
      setMensaje("Error al enviar el correo. Inténtalo de nuevo.");
    }
  };

  return (
    <div className="w-full md:w-1/2 p-4">
      <h2 className="text-lg font-bold">CONTÁCTANOS</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input type="text" name="nombre" placeholder="Nombre" value={formData.nombre} onChange={handleChange} className="w-full p-2 border rounded" required />
        <input type="email" name="email" placeholder="Correo Electrónico" value={formData.email} onChange={handleChange} className="w-full p-2 border rounded" required />
        <input type="tel" name="celular" placeholder="Celular" value={formData.celular} onChange={handleChange} className="w-full p-2 border rounded" />
        <input type="text" name="asunto" placeholder="Asunto" value={formData.asunto} onChange={handleChange} className="w-full p-2 border rounded" required />
        <textarea name="mensaje" placeholder="Mensaje" value={formData.mensaje} onChange={handleChange} className="w-full p-2 border rounded h-24" required></textarea>
        <div className="flex items-center">
          <input type="checkbox" name="aceptar" checked={formData.aceptar} onChange={handleChange} className="mr-2" />
          <span>Acepto términos y condiciones</span>
        </div>
        <button type="submit" className="bg-red-500 text-white px-4 py-2 rounded">ENVIAR</button>
      </form>
      {mensaje && <p className="mt-4 text-green-600">{mensaje}</p>}
    </div>
  );
};

export default Contacto;
